import React, {useState, useEffect} from "react";
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import UserPool from './components/autorize/UserPool';
import "./App.css";
import MainPage from "./page/MainPage/MainPage";
import {Account} from "./components/autorize/Account";
import LoginPage from "./page/LoginPage/LoginPage";
import ChangePsawordPage from "./page/ForgotPassword/LoginPage";
import NewPasswordPage from "./page/NewPassword/LoginPage";
import GSetingsPage from "./page/GroupSettingsPage/GSettingsPage";
import SegmentationPage from "./page/SegmentationPage/SegmentationPage";
import SegmentationPage_new from "./page/SegmentationPage_new/SegmentationPage";
import SegmentationDatasetPage from "./page/baket/SegmentationDatasetPage/SegmentationDatasetPage";
import Campaigns from "./page/CampaignsPage/CampaignsPage";
import Settings from "./page/SettingsPage/SettingsPage";
import Analytics from "./page/Analytics/Analytics";
import Powerbi from "./page/Powerbi/Powerbi";

import Assistant from "./page/Assistant/Assistant";
import Strategy from "./page/Strategy/Strategy";
import Compain from "./page/Compain/Compain";

import Flow from "./page/Flow/Flow";


import Datasets from "./page/Datasets/Datasets";
import FilesUpload from "./page/FilesUpload/FilesUpload";
import {Helmet} from "react-helmet";
import { LiveChatWidget, EventHandlerPayload } from "@livechat/widget-react";
import favicon from "../src/assets/favicon.png"
const INACTIVITY_TIMEOUT_SECONDS = 15 * 60;


function App() {
    const token = localStorage.getItem("token");
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    useEffect(() => {

        

        const token = localStorage.getItem("token");
        if (token) {
            const cognitoUser = UserPool.getCurrentUser();
            if (cognitoUser) {
                cognitoUser.getSession((err, session) => {
                    if (err) {
                        
                        console.error("Error fetching user session:", err); 
                        localStorage.setItem("token", "");
                        localStorage.setItem("countactivetime", Date.now().toString());
                        if (
                        !window.location.pathname.includes("login") &&
                        !window.location.pathname.includes("forgotpassword") &&
                        !window.location.pathname.includes("newpassword")
                        ) {
                        window.location.href = "/login";
                        }
                        return;                      
                    } 
                    else 
                    {
                        if (!session || !session.isValid()) {
                            console.log("Session is invalid");
                            localStorage.setItem("token", "");
                            localStorage.setItem("countactivetime", Date.now());
                            
                            if (
                                !window.location.pathname.includes("login") &&
                                !window.location.pathname.includes("forgotpassword") &&
                                !window.location.pathname.includes("newpassword")
                            ) {
                                window.location.href = "/login";
                            }
                            return;
                        }
                        else
                        {
                            /*
                            * getSession може автоматично оновити Cognito-сесію
                            * через refresh token.
                            *
                            * Тому після успішного getSession зберігаємо
                            * актуальний Access Token у localStorage.
                            */
                            const freshAccessToken = session
                                .getAccessToken()
                                .getJwtToken();

                            localStorage.setItem(
                                "token",
                                freshAccessToken
                            );

                            var countactivetime =
                                localStorage.getItem("countactivetime");

                            if (countactivetime !== null)
                            {
                                var huri =
                                    (Number(countactivetime) / 1000) +
                                    INACTIVITY_TIMEOUT_SECONDS;

                                var huriN = Date.now() / 1000;
                                const currentPath = window.location.pathname;

                                if (huriN > huri)
                                {
                                    localStorage.removeItem("token");

                                    localStorage.setItem(
                                        "countactivetime",
                                        Date.now().toString()
                                    );

                                    if (
                                        !currentPath.includes("login") &&
                                        !currentPath.includes("forgotpassword") &&
                                        !currentPath.includes("newpassword")
                                    ) {
                                        window.location.href = "/login";
                                    }
                                }
                            }
                            else
                            {
                                localStorage.setItem(
                                    "countactivetime",
                                    Date.now().toString()
                                );
                            }
                        }
                        
                    }
                });
            }
            else
            {
                console.log("User no authenticated");
                window.location.href = "/login";
                return;
            }
        } else {
            console.log("User not authenticated");
           
            if (window.location.pathname !== '/login'&&!window.location.pathname.includes("forgotpassword")&&!window.location.pathname.includes("newpassword")) {
                window.location.href = "/login";
            }
        }
        const handleActivity = () => {
            
            var countactivetime = localStorage.getItem("countactivetime");
            if(countactivetime!=undefined)
            {
                var huri = (countactivetime/1000)+600;
                var huriN = (Date.now()/1000);
                const currentPath = window.location.pathname;
                if(huriN>huri)
                {
                    localStorage.setItem("token", "");
                    localStorage.setItem("countactivetime", Date.now());
                    if(!currentPath.includes("login")&&!currentPath.includes("forgotpassword")&&!currentPath.includes("newpassword")){
                        window.location.href = "/login";
                    }
                }
                else
                {
                    localStorage.setItem("countactivetime", Date.now());
                }
            }
            else
            {
                localStorage.setItem("countactivetime", Date.now());
            }
        };
        const handleKeyDown = () => handleActivity();
        const handleMouseOver = () => handleActivity();

        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("mouseover", handleMouseOver);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("mouseover", handleMouseOver);
        };
    }, []);
    
    console.log(langmenu + "arifma")
    
    return (
        <>
       
            {
                langmenu=='de'?
                <Helmet>
                    <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
                    <title>Beinf.ai - Dein datengetriebenes KI-Marketing-Talent für mehr Kundentreue</title>
                    <meta name="description" content="Nutze prädiktive KI und ML, um hyperpersonalisierte Marketingkampagnen zu starten und die Kundentreue zu steigern."/>
                    <meta property="og:title" content="Beinf.ai - Dein datengetriebenes KI-Marketing-Talent für mehr Kundentreue"/>
                    <meta property="og:description" content="Nutze prädiktive KI und ML, um hyperpersonalisierte Marketingkampagnen zu starten und die Kundentreue zu steigern."/>
                    <meta property="og:site_name" content="Beinf"/>
                </Helmet>
                :
                <Helmet>
                    <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
                    <title>Beinf.ai - your data-driven AI marketing talent that drives loyalty</title>
                    <meta name="description" content="Leverage predictive AI & ML to launch hyper-personalised marketing campaigns and grow customer loyalty."/>
                    <meta property="og:title" content="Beinf.ai - your data-driven AI marketing talent that drives loyalty"/>
                    <meta property="og:description" content="Leverage predictive AI & ML to launch hyper-personalised marketing campaigns and grow customer loyalty."/>
                    <meta property="og:site_name" content="Beinf"/>
                </Helmet>
            }
            
        
        <Router>
            <Account>
                {
                    token?
                    <>
                        <Routes>
                           
                            <Route path="/" element={<MainPage/>}/>
                            <Route path="/login" element={<LoginPage/>}/>
                            <Route path="/forgotpassword" element={<ChangePsawordPage/>}/>
                            <Route path="/newpassword" element={<NewPasswordPage/>}/>
                            <Route path="/assistant" element={<Assistant/>}/>
                            <Route path="/strategy" element={<Strategy/>}/>
                            <Route path="/compain" element={<Compain/>}/>
                            <Route path="/flow" element={<Flow/>}/>
                            <Route path="/group-settings" element={<GSetingsPage/>}/>
                            <Route path="/customer_portraits" element={<SegmentationPage/>}/>
                            {/* <Route path="/segment_datasets" element={<SegmentationDatasetPage/>}/> */}
                            <Route path="/campaigns" element={<Campaigns/>}/>
                            <Route path="/analytics" element={<Analytics/>}/>
                            <Route path="/powerbi" element={<Powerbi/>}/>
                            <Route path="/products" element={<SegmentationPage_new/>}/>
                            <Route path="/datasets" element={<Datasets/>}/>
                            <Route path="/files_upload" element={<FilesUpload/>}/>
                            <Route path="/settings" element={<Settings/>}/>
                            <Route path="/:id_goal/compain/:id_comp" element={<Compain/>} />
                            <Route path="/create_compain/:id_goal" element={<Compain/>} />
                            <Route path="*" element={<LoginPage />} /> 
                        </Routes>
                        {/* <LiveChatWidget license="15041331"/> */}
                        {/* <div style={{position:"absolute", right:"20px", bottom:"20px"}} data-id="4228723608" class="livechat_button"><a href="https://www.livechat.com/?utm_source=chat_button&utm_medium=referral&utm_campaign=lc_15041331">live chat customer service</a></div> */}
                        {/* <div style={{position:"absolute", right:"20px", bottom:"20px"}} data-id="eVJwyyvaFMTD" class="livechat_button"><a href="https://www.livechat.com/?utm_source=chat_button&utm_medium=referral&utm_campaign=lc_15041331">Live Chat</a></div> */}
                        {/* <div style={{position:"absolute", right:"20px", bottom:"20px"}} data-id="TTYGEF1F5Tl" class="livechat_button"><a href="https://www.livechat.com/utm-builder/?utm_source=chat_button&utm_medium=referral&utm_campaign=lc_15041331">UTM Builder</a></div>  */}
                    </>
                    :
                    <Routes>
                        <Route path="/login" element={<LoginPage/>}/>
                        <Route path="/forgotpassword" element={<ChangePsawordPage/>}/>
                        <Route path="/newpassword" element={<NewPasswordPage/>}/>
                        <Route path="*" element={<LoginPage />} /> 
                    </Routes>
                }
            </Account>
        </Router>
        </>
    );
}

export default App;
